<div class="container">
  <alliance-clubs-back-button class="back-button 1300:santa-flex" [label]="translations.back | translate" [classes]="'santa-text-red-500'"></alliance-clubs-back-button>
  <santa-skeleton-loader
    [loading]="!state?.post"
    [empty]="!state?.post"
    [showProgressBar]="false"
    [skeleton]="state?.isMobileScreen ? SkeletonClubsPostMobile : SkeletonClubsPostDesktop"
    [skeletonWidth]="0"
    [useClasses]="'santa-flex santa-justify-center santa-my-40 santa-w-full'"
    class="posts-skeleton-loader"
  >
    <ng-template #content>
      <div class="wrapper">
        <!-- RUBRICS  -->
        <alliance-clubs-rubrics-list class="post-rubrics" [rubrics]="state?.post?.topics ?? []" [isPromo]="isPromo(state?.post?.tags ?? [])"></alliance-clubs-rubrics-list>

        <!-- HEADER  -->
        <h1 class="post-header">{{ state?.post?.title }}</h1>

        <!-- DESCRIPTION  -->
        <div class="post-description" *ngIf="state?.post?.userProfile?.fullName || state?.post?.publishedAt || state?.post?.viewsCount">
          <!--  AUTHOR  -->
          <div class="post-description-left post-description-author" *ngIf="state?.post?.userProfile?.fullName">
            <alliance-clubs-author [userProfile]="state?.post?.userProfile ?? null" [avatarImgSize]="40" [spacingBetween]="20" [direction]="'col'" [fullNameStyle]="'bold'"></alliance-clubs-author>
          </div>
          <!--  DATE & VIEWS  -->
          <div class="post-description-right" *ngIf="state?.post?.publishedAt || state?.post?.viewsCount">
            <alliance-clubs-date [date]="state?.post?.publishedAt ?? null"></alliance-clubs-date>
            <alliance-clubs-views [class.santa-ml-20]="state?.post?.publishedAt" [views]="state?.post?.viewsCount ?? 0"></alliance-clubs-views>
          </div>
        </div>

        <!--   IMAGE   -->
        <div *ngIf="state?.post?.thumbnail" class="post-image">
          <img width="100%" height="auto" loading="eager" [alt]="state.imageAttributes.alt" [title]="state.imageAttributes.title" [src]="state?.post?.thumbnail" />
        </div>

        <!-- CONTENT  -->
        <pre [innerHTML]="state?.post?.body ?? '' | bypassSanitizer: 'html'" class="post-content" (click)="openLinksOnNewTab($event)"></pre>

        <!-- TAGS  -->
        <ng-container *ngIf="state?.post?.tags?.length">
          <p class="santa-typo-secondary santa-text-black-700 santa-mt-20">{{ translations.tagsTitle | translate }}:</p>
          <alliance-clubs-tags-list class="post-tags" [tags]="state?.post?.tags ?? []"></alliance-clubs-tags-list>
        </ng-container>

        <!-- BREADCRUMBS -->
        <alliance-clubs-breadcrumbs class="post-breadcrumbs empty:santa-hidden" [items]="state?.breadcrumbs ?? []"></alliance-clubs-breadcrumbs>
      </div>
    </ng-template>
  </santa-skeleton-loader>
</div>

<!-- RELATED POSTS  -->
<div class="santa-bg-black-100 santa-mt-40" *ngIf="(state?.post?.relatedPosts?.items?.length ?? 0) > 0">
  <div class="post-related-container">
    <alliance-clubs-related-posts class="santa-mt-40" [relatedPosts]="state?.post?.relatedPosts?.items ?? null"></alliance-clubs-related-posts>
  </div>
</div>
